/**
 * DS Compare — Figma icon
 * ---------------------------------------------------------------
 * Swaps the placeholder compare icon in the PDP button for the exact vector
 * from the design file (Site 3.0 → "Compare-Ab Streamline Flex-Neon", 34×34).
 * Done here rather than in the section file so the section stays untouched.
 */
(function () {
  var ICON =
    '<svg class="dscmp-btn__icon" width="34" height="34" viewBox="0 0 34 34" fill="none" ' +
    'xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M6.37262 15.7584L9.00269 7.86816C9.13752 7.46368 9.51607 7.19086 9.94243 7.19086C10.3688 7.19086 10.7473 7.46368 10.8822 7.86816L13.5122 15.7584M7.32457 12.9025H12.5603" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M21.9947 18.5143V22.3496H24.9584C26.0175 22.3496 26.876 21.491 26.876 20.4319C26.876 19.3728 26.0175 18.5143 24.9584 18.5143H21.9947Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M21.9947 22.3492V26.8818H25.3069C26.5586 26.8818 27.5733 25.8672 27.5733 24.6155C27.5733 23.3639 26.5586 22.3492 25.3069 22.3492H21.9947Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M1.21429 11.973C1.21429 14.4616 1.34916 16.7925 1.67179 18.8431C1.89844 20.2837 2.88751 21.5012 4.26905 21.9681C5.80094 22.4857 7.37755 22.7317 9.942 22.7317C12.5064 22.7317 14.0831 22.4857 15.6149 21.9681C16.9965 21.5012 17.9856 20.2837 18.2122 18.8431C18.5348 16.7925 18.6696 14.4616 18.6696 11.9731C18.6696 9.4846 18.5347 7.15383 18.2121 5.10338C17.9855 3.6628 16.9964 2.44519 15.6148 1.97837C14.083 1.46074 12.5064 1.21478 9.9419 1.21478C7.37747 1.21478 5.80094 1.46056 4.26907 1.97807C2.88751 2.44483 1.89844 3.66244 1.67179 5.10302C1.34916 7.15356 1.21429 9.48453 1.21429 11.973Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M24.0204 11.2683C26.6145 11.2683 28.202 11.5179 29.751 12.0434C31.1158 12.5063 32.0936 13.7035 32.3197 15.1214C32.6475 17.1804 32.7845 19.5237 32.7845 22.0266C32.7845 24.5295 32.6475 26.8729 32.3197 28.9321C32.0938 30.3499 31.1158 31.5472 29.7512 32.01C28.2023 32.5356 26.6147 32.7852 24.0205 32.7852C21.4264 32.7852 19.8389 32.5356 18.2899 32.01C16.9253 31.5472 15.9473 30.3499 15.7214 28.9321C15.6439 28.4454 15.577 27.9427 15.5201 27.4256" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function swapIcon() {
    var btn = document.getElementById('dscmp-open');
    if (!btn || btn.dataset.dscmpIcon === '1') return;
    var old = btn.querySelector('svg');
    if (!old) return;
    btn.dataset.dscmpIcon = '1';
    old.outerHTML = ICON;
  }

  var mo = new MutationObserver(swapIcon);

  function start() {
    swapIcon();
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
